import { ContentForm } from "./AjoutConditionsEtTermes";

const AjoutMentionsLegales = () => {
  return <ContentForm type="cgv" />;
};

export default AjoutMentionsLegales;
